import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Tag, Timeline, Row, Col } from "antd";
import MaleBodyViewer from "../MaleBodyViewer"; // Updated import path
import { ArrowRightOutlined } from "@ant-design/icons";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import { getUserPainLocations } from "../redux-toolkit/slices/dashboardSlice";
import DashboardDateFilter from "./DashboardDateFilter";
import { formatDateInMMDDYYYY } from "../helpers/date";
import ViewPainTrackingExtendedNotesModal from "../modals/ViewPainTrackingExtendedNotesModal";

const { Title } = Typography;

const DashboardPainLocationDetails = () => {
  const [filter, setFilter] = useState<string>("7");
  const [show, setShow] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { isPainLocationsLoading, userPainData } = useSelector(
    (state: RootState) => state.dashboard
  );
  useEffect(() => {
    dispatch(getUserPainLocations("7"));
  }, []);
  const onFilterChange = (filter: string) => {
    setFilter(filter);
    dispatch(getUserPainLocations(filter));
  };

  const handleClose = (isReload: boolean) => {
    setShow(false);
  };
  return (
    <>
      {show === true && (
        <ViewPainTrackingExtendedNotesModal
          show={show}
          handleClose={handleClose}
        />
      )}

      <Card>
        {/* Row for the Title */}
        <Row>
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Title level={3}>Pain Location Insights</Title>
            <DashboardDateFilter value={filter} onChange={onFilterChange} />
          </Col>
        </Row>

        {/* Row for the Content */}
        <Row gutter={[20, 20]}>
          {/* Left Column: MaleBodyViewer */}
          <Col xs={24} md={8}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <MaleBodyViewer isBodyClickEnable={false} />
            </div>
          </Col>

          {/* Right Column: Overview */}
          <Col xs={24} md={16}>
            <Title level={4}>Overview</Title>

            <div style={{ marginBottom: "20px" }}>
              <Title level={5}>Pain types</Title>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {userPainData.painTypes.map((type) => (
                  <Tag key={type} className="showing-tags">
                    {type}
                  </Tag>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <Title level={5}>Pain triggers</Title>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {userPainData.triggerTracking.map((trigger) => (
                  <Tag key={trigger} className="showing-tags">
                    {trigger}
                  </Tag>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <Title level={5}>Notes</Title>
              <Timeline>
                {userPainData.notes.slice(0, 10).map((note) => (
                  <Timeline.Item key={note.note}>
                    <span style={{ color: "#475467" }}>
                      {formatDateInMMDDYYYY(new Date(note.createdAt), false)}
                    </span>{" "}
                    - <span style={{ color: "#101828" }}>{note.note}</span>
                  </Timeline.Item>
                ))}
              </Timeline>
            </div>

            <Button
              disabled={userPainData.notes.length < 10}
              onClick={(e) => setShow(true)}
              type="link"
              icon={<ArrowRightOutlined />}
              style={{ color: "#1E1E1E" }}
            >
              View More
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default DashboardPainLocationDetails;
